<div class="page-container">

  <div class="course-preview-header">
    <div class="header-row">
      <div class="header-text">
        <div class="top-line">
          <i class="bi bi-arrow-left-short" (click)="goBack()"></i>
          <h3 class="course-heading">Course Preview</h3>
        </div>
        <p class="sub-head">Review all course details before publishing</p>
      </div>

      <div class="button-group">
        <button class="btn btn-back" *ngIf="!courseId" (click)="goBackToPreviousStep()">
          <i class="bi bi-arrow-left"></i> Back
        </button>

		<ng-container *hasPermission="PermissionForStudents.COURSE_PUBLISH">
        <button class="btn btn-publish" [disabled]="isLoadingDraft || isLoadingPublish" (click)="publishCourse()">
          Publish
        </button>
		</ng-container>

		<ng-container *hasPermission="PermissionForStudents.COURSE_CREATE">
        <button class="btn btn-draft" [disabled]="isLoadingDraft || isLoadingPublish" (click)="saveAsDraft()">
          Save Draft
        </button>
		</ng-container>

      </div>
    </div>
    <div class="divider"></div>
  </div>

  <div *ngIf="coursePayload">

    <div class="course-details-card">
      <div class="course-details-header">
        <div class="course-details-icon">
          <i class="bi bi-mortarboard-fill"></i>
        </div>
        <div class="course-details-title">
          Course Details
          <div class="course-details-subtitle">Basic information</div>
        </div>
      </div>

      <div class="course-details-content">
        <div class="thumbnail-preview-wrapper" *ngIf="coursePayload.course_thumbnail">
          <div class="thumbnail-box">
            <img [src]="getThumbnailSrc()" alt="Course Thumbnail" class="course-thumbnail-img" />
          </div>
        </div>

        <div class="course-details-row">
          <div class="course-details-col">
            <div class="course-details-label">COURSE TITLE</div>
            <div class="course-details-value">{{ coursePayload.course_title }}</div>
          </div>

          <div class="course-details-col">
            <div class="course-details-label">COURSE CODE</div>
            <div class="course-details-value">{{ coursePayload.course_code }}</div>
          </div>

          <div class="course-details-col">
            <div class="course-details-label">GRADE</div>
            <div class="course-details-value">{{ coursePayload.grade_level }}</div>
          </div>
        </div>

        <div class="course-details-row">
          <div class="course-details-col">
            <!-- <div class="course-details-label">CREDITS</div>
            <div class="course-details-value">{{ coursePayload.credits }}</div>
          </div> -->

          <!-- <div class="course-details-col">
            <div class="course-details-label">CIE / SIE</div>
            <div class="course-details-value">
              {{ coursePayload.internal_marks }} / {{ coursePayload.exam_marks }}
            </div>
          </div> -->

          <div class="course-details-col">
            <div class="course-details-label">RATING</div>
            <div class="course-details-value">{{ coursePayload.rating || '--' }}</div>
          </div>
        </div>
        </div>
        <div class="course-details-row">
          <div class="course-details-col">
            <div class="course-details-label">DESCRIPTION</div>
            <div class="course-details-value" [innerHTML]="coursePayload.course_description || '-'"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="course-details-card">
      <div class="course-details-header">
        <div class="course-details-icon"><i class="bi bi-bullseye"></i></div>
        <div class="course-details-title">Course Objectives</div>
      </div>

      <div class="course-details-content">
        <ul *ngIf="coursePayload.course_objectives?.length; else noObjectives">
          <li *ngFor="let obj of coursePayload.course_objectives">{{ obj }}</li>
        </ul>
        <ng-template #noObjectives>
          <p class="text-muted text-center">No objectives added</p>
        </ng-template>
      </div>
    </div>

    <div class="course-details-card">
      <div class="course-details-header">
        <div class="course-details-icon"><i class="bi bi-book"></i></div>
        <div class="course-details-title">Modules & Lessons</div>
      </div>

      <div class="course-details-content">
        <div class="unit-card" *ngFor="let unit of coursePayload.units">
          <div class="unit-header">
            <div class="unit-title-row">{{ unit.unit_title }}</div>
            <div class="unit-duration">Duration: {{ unit.unit_hours }} minutes</div>
          </div>

          <div class="unit-topics">
            <div class="topic" *ngFor="let topic of unit.topics">
              <span class="dot"></span>
              <strong>{{ topic.topic_title }}</strong>
              <div class="topic-desc" [innerHTML]="topic.description"></div>

              <div class="subtopic" *ngFor="let sub of topic.subtopics">
                <span class="sub-dot"></span>
                <strong>{{ sub.subtopic_title }}</strong>
                <div class="sub-desc" [innerHTML]="sub.description"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="course-details-card">
      <div class="course-details-header">
        <div class="course-details-icon"><i class="bi bi-award-fill"></i></div>
        <div class="course-details-title">Course Outcomes</div>
      </div>

      <div class="course-details-content">
        <ul *ngIf="coursePayload.course_outcomes?.length; else noOutcomes">
          <li *ngFor="let outcome of coursePayload.course_outcomes">{{ outcome }}</li>
        </ul>
        <ng-template #noOutcomes>
          <p class="text-muted text-center">No outcomes added</p>
        </ng-template>
      </div>
    </div>


    <div class="course-details-card">
      <div class="course-details-header">
        <div class="course-details-icon">
          <i class="bi bi-book-half"></i>
        </div>
        <div class="course-details-title">
          Textbooks
          <div class="course-details-subtitle">Reference books for this course</div>
        </div>
      </div>

      <div class="course-details-content">
        <ng-container *ngIf="coursePayload.textbooks?.length; else noTextbooks">
          <div class="resource-card" *ngFor="let book of coursePayload.textbooks; let i = index">

            <div class="resource-name-row">
              <span class="resource-count">{{ i + 1 }}</span>
              <span class="resource-name">{{ book.title || '-' }}</span>
            </div>

            <div class="resource-details">
              <span>{{ book.author || '-' }}</span>
              <span>{{ book.publisher || '-' }}</span>
              <span *ngIf="book.year">{{ book.year }}</span>
              <span *ngIf="book.isbn">ISBN: {{ book.isbn }}</span>
            </div>
          </div>
        </ng-container>

        <ng-template #noTextbooks>
          <p class="text-muted text-center">No textbooks added</p>
        </ng-template>
      </div>
    </div>

    <div class="course-details-card">
      <div class="course-details-header">
        <div class="course-details-icon">
          <i class="bi bi-link-45deg"></i>
        </div>
        <div class="course-details-title">
          Web Resources
          <div class="course-details-subtitle">Helpful external links</div>
        </div>
      </div>

      <div class="course-details-content">
        <ng-container *ngIf="coursePayload.web_references_links?.length; else noWebLinks">
          <div class="resource-card" *ngFor="let link of coursePayload.web_references_links; let i = index">

            <div class="resource-name-row">
              <span class="resource-count">{{ i + 1 }}</span>
              <a [href]="link" target="_blank" rel="noopener noreferrer" class="resource-name">
                {{ link }}
              </a>
            </div>
          </div>
        </ng-container>

        <ng-template #noWebLinks>
          <p class="text-muted text-center">No web resources added</p>
        </ng-template>
      </div>
    </div>

    <div class="loader-backdrop" *ngIf="isLoadingDraft || isLoadingPublish">
      <div class="loader"></div>
    </div>

    <div class="course-details-card">
      <div class="course-details-header">
        <div class="course-details-icon"><i class="bi bi-file-earmark-text-fill"></i></div>
        <div class="course-details-title">Course Document</div>
      </div>

      <div class="course-details-content text-center">
        <button *ngIf="coursePayload.course_document" class="btn btn-outline" (click)="downloadDocument()">
          <i class="bi bi-download"></i> Download Course Document
        </button>
        <p *ngIf="!coursePayload.course_document" class="text-muted">
          No document uploaded
        </p>
      </div>
    </div>
  </div>
</div>